import { formatDate } from "./gestionCarteraFormat";

/**
 * Catálogo de la factura del comercio por crédito (modal Factura del listado y fila Factura de Documentos).
 *
 * Los créditos vienen de GET /v1/portfolio/clients/{clientUuid}/credit-invoices, ya ordenados del
 * originado más reciente al más antiguo. `invoiceName` es `credits.invoice_names` (llave en S3);
 * `credits.invoice_uuid` NO es la factura del comercio: es el SiigoDocument de la factura de comisión.
 */

const isValidKey = (key) => Boolean(key) && key !== "null" && key !== "undefined";

/** Créditos a los que se puede cargar factura (backend: APPROVED o COMPLETED), en el mismo orden. */
export const invoiceableCredits = (credits) => (credits || []).filter((credit) => credit?.invoiceable === true);

/** El crédito tiene factura del comercio si tiene archivo o `facturaEnviada = true`. */
export const hasCreditInvoice = (credit) => isValidKey(credit?.invoiceName) || credit?.facturaEnviada === true;

/** Llaves S3 de las facturas que se pueden abrir, sin repetir. */
export const creditInvoiceKeys = (credits) => [
  ...new Set((credits || []).map((credit) => credit?.invoiceName).filter(isValidKey)),
];

export const creditInvoiceOptionLabel = (credit) => {
  const origin = credit.originDate ? ` · originado el ${formatDate(credit.originDate)}` : "";
  const invoice = hasCreditInvoice(credit) ? "con factura" : "sin factura";
  return `Crédito ${credit.oldId ?? "—"} · ${credit.status}${origin} · ${invoice}`;
};
